var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatteryUp1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 886,
    height: 288,
    viewBox: "0 0 886 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.24 31.3922C208.24 31.3922 208.24 7 232.632 7C257.025 7 781.457 7 818.045 7C854.633 7 860.731 43.5883 860.731 43.5883L879.025 150.304C879.025 150.304 879.025 245.561 879.025 257.02C879.025 281.412 854.633 281.412 854.633 281.412C854.633 281.412 269.221 281.412 238.73 281.412C208.24 281.412 208.24 250.922 208.24 250.922V31.3922Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 12.1961
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M850.71 53.1343C850.765 53.2845 850.806 53.4013 850.832 53.4799L850.911 53.8978C850.986 54.2865 851.095 54.8586 851.234 55.592C851.513 57.0587 851.915 59.1705 852.402 61.7498C853.378 66.9086 854.7 73.9367 856.086 81.4149C858.865 96.4062 861.88 113.102 862.893 120.239C863.928 127.528 864.081 132.209 863.226 135C862.84 136.262 862.309 136.918 861.717 137.315C861.081 137.741 860.017 138.104 858.163 138.104L720.472 138.104C715.931 138.104 712.504 138.102 709.78 137.876C707.05 137.65 705.379 137.22 704.227 136.581C702.163 135.436 700.76 133.056 699.221 125.313C698.961 124.005 698.669 122.543 698.352 120.954C694.952 103.914 688.642 72.2863 687.142 58.4998C686.369 51.3883 687.844 47.0407 690.145 44.4777C692.453 41.9065 696.125 40.5354 701.025 40.5354L832.448 40.5354C839.842 40.5354 844.376 43.8147 847.134 47.0774C848.538 48.7374 849.487 50.4066 850.083 51.659C850.379 52.282 850.583 52.7926 850.71 53.1343ZM850.866 53.5877L850.866 53.5868C850.868 53.5915 850.868 53.5943 850.869 53.5951L850.868 53.5916L850.866 53.5877Z",
    fill: "#9AFF6B",
    stroke: "#9AFF6B",
    strokeWidth: 6.09805
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 31.3922C7 31.3922 7 7 31.3922 7C55.7844 7 580.216 7 616.805 7C653.393 7 659.491 43.5883 659.491 43.5883L677.785 150.304C677.785 150.304 677.785 245.561 677.785 257.02C677.785 281.412 653.393 281.412 653.393 281.412C653.393 281.412 67.9805 281.412 37.4902 281.412C7 281.412 7 250.922 7 250.922V31.3922Z",
    fill: "black",
    stroke: "#9AFF6B",
    strokeWidth: 12.1961
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M564.974 43.5938C543.631 43.5938 543.631 59.4286 543.631 72.5448V120.049C543.631 120.049 543.632 141.162 564.971 141.162H619.856C647.298 141.162 649.102 133.158 647.073 111.892C645.045 90.6253 645.97 43.5938 607.66 43.5938H564.974Z",
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 6.09805
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 159.445,
    y: 43.5938,
    width: 115.863,
    height: 97.5687,
    rx: 12.1961,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 6.09805
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.3926,
    y: 43.5938,
    width: 115.863,
    height: 97.5687,
    rx: 12.1961,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 6.09805
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 287.512,
    y: 43.5938,
    width: 115.863,
    height: 97.5687,
    rx: 12.1961,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 6.09805
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 415.564,
    y: 43.5938,
    width: 115.863,
    height: 97.5687,
    rx: 12.1961,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 6.09805
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M708.279 232.633L866.829 232.633",
    stroke: "#9AFF6B",
    strokeWidth: 12.1961,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4863 196.039L641.193 196.039",
    stroke: "#9AFF6B",
    strokeWidth: 12.1961,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryUp1);
export default __webpack_public_path__ + "static/media/battery-up1.9a6ff0a5c0ce1cb33f2656822f8530fc.svg";
export { ForwardRef as ReactComponent };